// ==============start code after speed optimization ============//
$('.video-thumb').click(function () {
          var $this      = $(this);
          var data_video = $this.attr('data-video');
          var video_url  = `https://www.youtube.com/embed/${data_video}?color=white&showinfo=0&rel=0&enablejsapi=1&modestbranding=1&ecver=2&origin=https%3A%2F%2Fgreenherbalcare.com&widgetid=1&autoplay=1`;
          var iframeHtml =`<iframe id="player" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" title="Greenharbal" width="560" height="315" src="${video_url}"></iframe>`
          $('.fullsection-vid #myModal .embed__container').html(iframeHtml);
          $('.video-thumb').removeClass('active');
          $this.addClass('active');
          $(".fullsection-vid #myModal").modal({show: true});
});
$('#myModal .close').click(function () {
      $('#player').attr('src', '');
});
$(".video_gallary_thumb").owlCarousel({ 
        items:4,   
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [980,3],
        itemsTablet: [768,3],
        // itemsTabletSmall: [768,3],
        itemsMobile : [479,2],
        navigation:true,
        navigationText: [
           "<i class='fa fa-chevron-left'></i>",
           "<i class='fa fa-chevron-right'></i>"
        ]
})
// ==============end code after speed optimization ============//